export default "__VITE_ASSET__DG6EHt5C__"